export const public_index_dictionary = {
  audience: 'Аудитория',
  business: 'Бизнес',
  availability: 'Доступность',
  attract_cnt_BC: 'Количество Бизнес Цетров',
  attract_cnt_TC: 'Количество Торговых Цетров',
  attract_cnt_TRC: 'Количество Торгово-развлекательных Цетров',
  competitors_cnt_B: 'Количество конкурентов',
  competitors_cnt_B1: 'Автосервисы, мойка, запчасти',
  competitors_cnt_B2: 'Алкоголь',
  competitors_cnt_B3: 'Аптеки',
  // competitors_cnt_B4: 'Банки и банкоматы',
  competitors_cnt_B4: 'Бытовая техника и электроника',
  // competitors_cnt_B6: 'Гостиницы и места размещения',
  competitors_cnt_B5: 'Зоомагазины и услуги для животных',
  competitors_cnt_B6: 'Кафе, рестораны и бары',
  competitors_cnt_B7: 'Книги и канцтовары',
  competitors_cnt_B8: 'Косметика и парфюмерия',
  competitors_cnt_B9: 'Магазины цветов и доставка',
  competitors_cnt_B10: 'Мебель',
  competitors_cnt_B11: 'Медицинские лаборатории',
  competitors_cnt_B12: 'Одежда и аксессуары',
  competitors_cnt_B13: 'Оптика',
  // competitors_cnt_B16: 'Полиграфия и фото',
  competitors_cnt_B14: 'Продуктовый ритейл',
  // competitors_cnt_B18: 'Пункты выдачи и постаматы',
  competitors_cnt_B15: 'Ремонт и строительные материалы',
  competitors_cnt_B16: 'Ремонт одежды и обуви',
  competitors_cnt_B17: 'Ремонт техники',
  competitors_cnt_B18: 'Салоны красоты',
  competitors_cnt_B19: 'Спортивные клубы',
  competitors_cnt_B20: 'Табак',
  competitors_cnt_B21: 'Товары для дома',
  competitors_cnt_B22: 'Химчистка',
  competitors_cnt_B23: 'Ювелирные изделия',
  competitors_cnt_B24: 'Юридические и нотариальные услуги',
  households: 'Количество домохозяйств',
  income_avg_range: 'Средний уровень дохода',
  parking_cnt: 'Количество парковок',
  parking_place_cnt: 'Количество парковочных мест',
  pedestrian_connect: 'Пешеходная связанность территорий',
  population_age_18_29: 'Жителей от 18 до 29 лет',
  population_age_30_44: 'Жителей от 30 до 44 лет',
  population_age_45_60: 'Жителей от 45 до 60 лет',
  'population_age_61-100': 'Жителей от 61 года',
  population_sex_m: 'Количество мужчин',
  population_sex_w: 'Количество женщин',
  population_total: 'Численность населения',
  price_per_sq_m_Com: 'Средняя стоимость аренды ком недвижимости за кв метр',
  pt_route_cnt: 'Количество маршрутов общественного транспорта',
  pt_stops_cnt: 'Количество остановок общественного транспорта',
  rent_price_range: 'Средняя стоимость аренды коммерческой недвижимости',
  tj_lvl_avg: 'Среднесуточная затрудненность автомобильного движения',
  tj_lvl_max: 'Максимальная затрудненность автомобильного движения',
  provision_B: 'Обеспеченность населения, объектов / тыс. человек',
  income_median: 'Средний уровень дохода',
};

export const modal_values_dictionary = {
  population_sex_m: 'мужчины',
  population_sex_w: 'женщины',
  population_age_18_29: '18-29',
  population_age_30_44: '30-44',
  population_age_45_60: '45-60',
  'population_age_61-100': 'старше 60',
};

export const range_values_dict = {
  1: 'низкий',
  2: 'ниже среднего',
  3: 'средний',
  4: 'выше среднего',
  5: 'высокий',
};
